var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "bj-modal",
        {
          attrs: { size: "auto", title: "Generate Device Code" },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            !_vm.loading
              ? _c("div", [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n        Generated device code for " +
                        _vm._s(
                          _vm
                            .moment()
                            .tz(_vm.unit.property.timezone)
                            .format("MM/DD/YY")
                        ) +
                        "\n      "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c("span", { staticClass: "font-weight-bold" }, [
                        _vm._v("device code:")
                      ]),
                      _c("span", [
                        _vm._v(
                          "\n          " + _vm._s(_vm.deviceCode) + "\n        "
                        )
                      ]),
                      _c("SdCopyToClipboard", {
                        staticClass: "ml-2",
                        attrs: { "with-icon": "", copy: _vm.deviceCode }
                      })
                    ],
                    1
                  )
                ])
              : _c(
                  "div",
                  [
                    _vm._v("\n      Loading your device code...\n      "),
                    _c("q-spinner-puff", {
                      attrs: { color: "primary", size: "60px" }
                    })
                  ],
                  1
                ),
            _c(
              "div",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { rounded: "", flat: "" } },
                  [
                    _c("q-btn", {
                      attrs: {
                        rounded: "",
                        color: "primary",
                        size: "lg",
                        outline: "",
                        label: "Close",
                        "no-caps": ""
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close($event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }